import { Component, HostListener } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { IUtils } from '@lmnop/web-core';
import { InPageNavigateNavbarItem, NavbarItem, SiteUrlNavigateNavbarItem } from './navbar-item.classes';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'navbar-control',
    templateUrl: 'navbar.control.html',
    styleUrl: './navbar.control.scss',
    standalone: false,
})
export class NavbarControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.utils = this.ioc.core.utils;
    }

    public utils: IUtils;

    public items: NavbarItem[] = [];

    public isMenuCollapsed: boolean = true;
    public showToPageTop: boolean = false;
    public showTogglerButton: boolean = false;

    private navbarElement: Element = null;
    private allSiteUrlNavigationElementInNav: NodeListOf<Element> = null;
    private allInPageNavigationElementInNav: NodeListOf<Element> = null;

    public clearNavbarItems(): void {
        this.items = [];
        this.allSiteUrlNavigationElementInNav = null;
        this.allInPageNavigationElementInNav = null;
    }

    @HostListener('window:resize', ['$event'])
    public onResize(e: Event): void {
        this.initNavbar();
    }

    @HostListener('window:scroll', ['$event'])
    public onWindowScroll(e: Event): void {
        this.initNavbar();
    }

    isInPageItem(item: NavbarItem): item is InPageNavigateNavbarItem {
        return item instanceof InPageNavigateNavbarItem;
    }

    isSiteUrlItem(item: NavbarItem): item is SiteUrlNavigateNavbarItem {
        return item instanceof SiteUrlNavigateNavbarItem;
    }

    public initNavbar(): void {
        if (this.allSiteUrlNavigationElementInNav == null) {
            this.allSiteUrlNavigationElementInNav = document.querySelectorAll(`nav.navbar#mainNav a[siteUrlNavigation]`);
        }
        if (this.allInPageNavigationElementInNav == null) {
            this.allInPageNavigationElementInNav = document.querySelectorAll(`nav.navbar#mainNav a[scrollToElementId]`);
        }
        if (this.navbarElement == null) {
            this.navbarElement = document.querySelector('.navbar');
        }
        this.showTogglerButton = this.allSiteUrlNavigationElementInNav.length + this.allInPageNavigationElementInNav.length > 0;

        if (window.pageYOffset > this.navbarElement.clientHeight) {
            this.navbarElement.classList.add('navbar-shrink');
            this.showToPageTop = true;
        } else {
            this.navbarElement.classList.remove('navbar-shrink');
            this.showToPageTop = false;
        }

        let setActive: boolean = false;
        for (let i: number = 0; i < this.allInPageNavigationElementInNav.length; i++) {
            let currentAElement: Element = this.allInPageNavigationElementInNav[i];
            let scrollToElementId: string = currentAElement.attributes.getNamedItem('scrollToElementId').nodeValue;
            let currentTargetElement: HTMLElement = document.getElementById(scrollToElementId);

            let nextAElement: Element = null;
            let nextTargetElement: HTMLElement = null;
            if (i < this.allInPageNavigationElementInNav.length - 1) {
                nextAElement = this.allInPageNavigationElementInNav[i + 1];
                nextTargetElement = document.getElementById(nextAElement.attributes.getNamedItem('scrollToElementId').nodeValue);
            }

            let isLastElement: boolean = nextTargetElement == null;

            let navbarHeigth: number = 50;
            let pageYOffset: number = window.pageYOffset + navbarHeigth;
            if (isLastElement && pageYOffset >= currentTargetElement?.offsetTop) {
                setActive = true;
            } else if (!isLastElement && pageYOffset >= currentTargetElement?.offsetTop && pageYOffset < nextTargetElement.offsetTop) {
                setActive = true;
            }

            if (setActive) {
                this.setNavbarActiveElement(this.allInPageNavigationElementInNav, currentAElement);
                this.setLocationHref(scrollToElementId);
                break;
            }
        }
        if (!setActive) {
            this.setNavbarActiveElement(this.allInPageNavigationElementInNav);
            this.setLocationHref();
        }
    }

    private setNavbarActiveElement(allAElementInNav: NodeListOf<Element>, navElement: Element = null): void {
        allAElementInNav.forEach((aElement: Element): void => {
            aElement.classList.remove('active');
        });
        if (navElement) {
            navElement.classList.add('active');
        }
    }

    private setLocationHref(scrollToElementId: string = ''): void {
        if (scrollToElementId) {
            history.pushState({}, '', window.location.origin + window.location.pathname + '#' + scrollToElementId);
        } else {
            history.pushState({}, '', window.location.origin + window.location.pathname);
        }
    }
}
